import { Component } from 'react';
import { reportarError } from '../utils/sentry';
import { dsv2 } from '../styles/designSystemV2';
import i18n from '../i18n';
import { Wrench } from 'lucide-react';

// ErrorBoundary DEBE ser un class component (React no soporta
// error boundaries con hooks todavía)
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportarError(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          minHeight: '100vh', padding: '40px 20px',
          backgroundColor: '#F9FAFB', textAlign: 'center'
        }}>
          <Wrench size={64} color={dsv2.red} style={{ marginBottom: '20px' }} />
          <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', marginBottom: '12px' }}>
            {i18n.t('errorBoundary.title')}
          </h1>
          <p style={{ fontSize: '16px', color: '#6B7280', marginBottom: '30px', maxWidth: '400px', lineHeight: '1.5' }}>
            {i18n.t('errorBoundary.body')}
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '14px 32px', backgroundColor: dsv2.red,
              color: 'white', border: 'none', borderRadius: dsv2.radius.md,
              fontSize: '16px', fontWeight: '600', cursor: 'pointer',
              boxShadow: dsv2.shadow.md
            }}
          >
            {i18n.t('errorBoundary.backHome')}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
